import { render, staticRenderFns } from "./OrderGoods.vue?vue&type=template&id=5d054fd4&scoped=true&"
import script from "./OrderGoods.vue?vue&type=script&lang=js&"
export * from "./OrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./OrderGoods.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderGoods.vue?vue&type=style&index=1&id=5d054fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d054fd4",
  null
  
)

export default component.exports